<template>
  <div id>
    <v-container fluid class="pt-0">
      <v-row>
        <v-col cols="12" class="pt-0">
          <v-card style="min-height:85vh" class="admin_secondary">
            <v-card-title class="secondary white--text">
              Portals
              <v-spacer></v-spacer>
              <v-btn icon dark @click="load" :loading="loading">
                <v-icon>fa-sync</v-icon>
              </v-btn>
            </v-card-title>
            <v-container class="white--text">
              <v-row align="center">
                <v-col cols="12" md="4" lg="3" xl="2">
                  <v-text-field
                    v-model="search"
                    append-icon="fa-search"
                    dark
                    label="Search"
                    outlined
                    hide-details
                    clearable
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-data-table :loading="loading" :headers="headers" :items="items" :search="search">
                <template v-slot:item.date_added="{ item }">
                  <span>{{item.date_added| fromNow}}</span>
                </template>
                <template v-slot:item.last_active="{ item }">
                  <span v-if="item.last_active">{{item.last_active| fromNow}}</span>
                  <span v-else>-</span>
                </template>

                <template v-slot:item.name="{ item }">
                  <router-link :to="`/admin/portals/${item.id}`">{{item.name}}</router-link>
                </template>

                <template v-slot:item.user.name="{ item }">
                  <router-link :to="`/admin/users/${item.user.id}`">{{item.user.name}}</router-link>
                </template>

                <template v-slot:item.user.membership_type="{ item }">
                  <span
                    :style="`${$store.state.website.memberships[item.user.membership_type].style} -webkit-background-clip: text;-webkit-text-fill-color: transparent;`"
                    class="font-weight-bold"
                  >{{$store.state.website.memberships[item.user.membership_type].label}}</span>
                </template>

                <template v-slot:item.edit_requests="{ item }">
                  <v-btn
                    text
                    :color="item.edit_requests.length ? 'primary' : 'grey'"
                  >{{item.edit_requests.length}}</v-btn>
                </template>

                <template
                  v-slot:item.size="{ item }"
                >{{(item.size > (500 * 1000 * 1000) ? `${(item.size / 1000 / 1000 / 1000).toFixed(2)}gb` : `${(item.size / 1000 / 1000).toFixed(2) }mb` )}}</template>

                <template v-slot:item.notification="{ item }">
                  <v-btn
                    icon
                    small
                    color
                    @click="$eventBus.$emit('send_notification',{user:item.user,portal: item})"
                  >
                    <v-icon small>fa-paper-plane</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import headers from "@/assets/table_headers/admin_portals.json";
export default {
  name: "AdminPortals",
  data() {
    return {
      headers: headers,
      items: [],
      search: "",
      loading: false
    };
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        this.items = await this.$api(`/admin/portals`);
      } catch (ex) {
        alert(ex.error);
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>